import styled from "styled-components";

import paw from "../../assets/paw.svg";
import { DogRatings, CoupleRatings } from "../../app/dog-rating";
import useDogs from "../../app/use-dogs";
import DogRow from "./DogRow";
import { QuizType } from "./quiz-data";

const StyledTopTenDogs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 17.5rem 0;
  width: 100%;

  @media (max-width: 900px) {
    margin: 12rem 0;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 3rem;
  margin-bottom: 6rem;

  @media (max-width: 900px) {
    gap: 2rem;
    margin-bottom: 4rem;
  }
`;

const Paw = styled.img`
  width: 7rem;
`;

const Header = styled.div`
  font-size: 4rem;
  font-weight: 650;

  @media (max-width: 900px) {
    text-align: center;
    max-width: 32rem;
  }
`;

const RowHeader = styled.div`
  display: flex;
  width: 100%;
  border-bottom: solid 1px var(--sub);
  align-items: center;
  height: 5rem;
  margin-bottom: 1rem;

  @media (max-width: 900px) {
    height: 4rem;
    > div:last-child {
      display: none;
    }
  }
`;

const RowItem = styled.div<{ $flex: number }>`
  flex: ${({ $flex }) => $flex};
  font-size: 2rem;
  font-weight: 500;
  font-family: "Jost", sans-serif;

  @media (max-width: 900px) {
    font-size: 1.8rem;
    white-space: nowrap;
  }
`;

interface Props {
  ratings: DogRatings;
  quiz: QuizType;
  coupleRatings?: CoupleRatings | null;
}

const TopTenDogs = ({ ratings, quiz, coupleRatings }: Props) => {
  const { dogs } = useDogs();

  if (!dogs) return null;

  return (
    <StyledTopTenDogs>
      <HeaderContainer>
        <Paw src={paw} alt="paw" />
        <Header>Top 10 most compatible dogs</Header>
      </HeaderContainer>
      <RowHeader>
        <RowItem $flex={2}>Ranking</RowItem>
        <RowItem $flex={4}>Breed Name</RowItem>
        <RowItem $flex={1}>% Match</RowItem>
        <RowItem $flex={4}>Key Characteristics</RowItem>
      </RowHeader>
      {dogs
        .sort((a, b) => ratings[b.id].percent - ratings[a.id].percent)
        .slice(0, 10)
        .map((dog, index) => (
          <DogRow
            key={dog.id}
            dog={dog}
            rating={ratings[dog.id]}
            quiz={quiz}
            place={index + 1}
            coupleRatings={coupleRatings}
          />
        ))}
    </StyledTopTenDogs>
  );
};

export default TopTenDogs;
